import { ErrorActions, PUSH_ERROR_MESSAGE, CLEAR_ERROR_MESSAGES } from '../actions/error.actions';
import { deepfind } from 'app/shared/utils/utils';


export class ErrorState { messages: string[]; }

const intitialState: ErrorState = {
    messages: null
};

export function errorReducer(state: ErrorState = intitialState, action: ErrorActions) {
    switch (action.type) {

        case PUSH_ERROR_MESSAGE: {
            const message =
                deepfind(action.payload, 'error.error.message') ||
                deepfind(action.payload, 'error.message') ||
                deepfind(action.payload, 'message') ||
                'Something went wrong. Please try again!';
            console.error(action.payload);
            if (state.messages) {
                return {
                    ...state,
                    messages: [message]
                };
            } else {
                return {
                    ...state,
                    messages: [message]
                };
            }
        }

        case CLEAR_ERROR_MESSAGES: {
            return intitialState;
        }

        default: return state;
    }
}
